export const childAgeOptions = Array.from({ length: 18 }, (_, i) => ({
    value: i.toString(),
    label: i === 0 ? 'Under 1 år' : i.toString(),
}));
